import { render, staticRenderFns } from "./RegionDetect.vue?vue&type=template&id=327e0d08&scoped=true&lang=pug"
import script from "./RegionDetect.vue?vue&type=script&lang=js"
export * from "./RegionDetect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e0d08",
  null
  
)

export default component.exports